import { Spinner } from "@/components";
import { color } from "@/styles/primitives";
import * as styles from "./Display.css";

export default function () {
	return (
		<Spinner
			size="32px"
			color={color.darkTeal}
			borderWidth="2px"
			className={styles.spinner}
		/>
	);
}
